// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20402-活动详情查询 GET /app/v1/promotion/detail/${param0} */
export async function getPromotionDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPromotionDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimPromotionDetailVo>(
    `/app/v1/promotion/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20401-活动列表查询 POST /app/v1/promotion/list/${param0} */
export async function getPromotionPageList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPromotionPageListParams,
  body: API.SwimPromotionPageQueryVo,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOYmPageResVOSwimPromotionListVo>(
    `/app/v1/promotion/list/${param0}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}
